import { observable, action, computed, configure } from "mobx";
import { ZoneId } from "js-joda";
import MobileDetect from "mobile-detect";
import authStore from "./auth";

configure({ enforceActions: true });

const mobileDetect = new MobileDetect(window.navigator.userAgent);

export class Store {
  authStore = authStore;

  @observable mobile = mobileDetect.mobile();

  @observable zoneId = ZoneId.SYSTEM;
  @computed
  get isZoneIdUTC() {
    return this.zoneId === ZoneId.UTC;
  }
  @action
  toggleZoneId = () => {
    this.zoneId = this.isZoneIdUTC ? ZoneId.SYSTEM : ZoneId.UTC;
  };

  @observable
  botSectionsExpanded = {
    config: false,
    state: false,
    stats: false,
    statsCandles: false,
    openTrades: true,
    closedTrades: false,
  };
  isBotSectionExpanded = section => this.botSectionsExpanded[section];
  @action
  toggleBotSectionExpanded = section => {
    this.botSectionsExpanded[section] = !this.botSectionsExpanded[section];
  };

  @observable
  simSectionsExpanded = {
    config: false,
    stats: false,
    statsCandles: false,
    closedTrades: false,
    openTrades: false,
  };
  isSimSectionExpanded = section => this.simSectionsExpanded[section];
  @action
  toggleSimSectionExpanded = section => {
    this.simSectionsExpanded[section] = !this.simSectionsExpanded[section];
  };

  @observable
  chartsDisplayed = {
    closedProfitCumulative: true,
    closedProfit: true,
  };
  isChartDisplayed = chart => this.chartsDisplayed[chart];
  @action
  toggleChartDisplayed = chart => {
    this.chartsDisplayed[chart] = !this.chartsDisplayed[chart];
  };
}

const store = new Store();

export default store;



// WEBPACK FOOTER //
// ./src/Store.js